import { css } from '@microsoft/fast-element';
export const actionsMenuBaseStyles = (context, definition) => css `
  :host {
    --actions-opener-height-multiplier: 0.7px;
    --actions-opener-bg-color: 249 254 255;
    --menu-item-height-multiplier: 0.7px;
  }

  .actions-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: right;
  }

  .actions-menu {
    display: none;
    position: absolute;
    max-width: 350px;
    overflow-y: auto;
  }

  .actions-vertical .actions-menu {
    padding: calc(var(--design-unit) * 1px);
    max-height: 175px;
    z-index: 100;
  }

  .actions-menu:not(.hidden):hover {
    display: inline-flex;
  }

  .hidden {
    display: none;
  }

  .visible {
    display: inline-flex;
  }

  .actions-opener {
    align-self: center;
    display: flex;
    height: calc(
      (var(--base-height-multiplier) + var(--density)) * var(--design-unit) *
        var(--actions-opener-height-multiplier)
    );
  }

  svg {
    width: 100%;
    height: 100%;
    fill: #879ba6;
  }

  .actions-opener:hover svg {
    fill: #fff;
  }

  foundation-menu-item {
    display: flex;
    user-select: none;
  }

  foundation-menu-item::part(content) {
    margin-inline: 10px;
  }

  foundation-menu-item[disabled] {
    pointer-events: none;
  }

  .menu-item {
    flex: 1;
    max-height: calc(
      (var(--base-height-multiplier) + var(--density)) * var(--design-unit) *
        var(--menu-item-height-multiplier)
    );
    min-height: 0;
  }

  .actions-vertical .menu-item {
    flex: 1 1 auto;
    justify-content: center;
    margin: calc(var(--design-unit) * 1px);
  }

  .actions-vertical .visible,
  .actions-vertical .actions-menu:not(.hidden):hover {
    display: flex;
    flex-direction: column;
  }
`;
export const foundationActionsMenuStyles = (context, definition) => css `
  ${actionsMenuBaseStyles(context, definition)}
`;
